// src/contexts/PacoteContext.tsx
import React, { createContext, useState, useContext, ReactNode } from "react";

/**
 * Tipos locais (baseados no seu PacoteDTO do backend)
 */
export type DiferencialDTO = {
  id?: number;
  tipo: string;
  descricaoCustomizada?: string | null;
  quantidade?: number;
};

export type StatusVeiculoType = "PENDENTE" | "APROVADO" | "REJEITADO" | string;

export type PacoteDTO = {
  id?: number;
  titulo?: string;
  descricao?: string;
  precoBase?: number;

  empresaId?: number | null;
  empresaNome?: string | null;

  motoristaIds?: number[];       
  motoristaNomes?: string[];     

  servicoId?: number | null;
  servicoNome?: string | null;

  // arquivos (IDs e URLs retornados pelo backend)
  fotoIds?: number[];
  fotoUrls?: string[];
  videoIds?: number[];
  videoUrls?: string[];

  duracaoEmMinutos?: number | null;
  idiomas?: string[];
  idadeMinima?: number | null;
  publicoAlvo?: string | null;

  pontosDeInteresse?: string[];
  pontosImportantes?: string[];
  diferenciais?: DiferencialDTO[];

  status?: StatusVeiculoType;
  motivoReprovacao?: string | null;

  ativo?: boolean;
};

/**
 * Tipo do contexto
 */
type PacoteContextType = {
  pacotes: PacoteDTO[];
  setPacotes: React.Dispatch<React.SetStateAction<PacoteDTO[]>>;
};

/**
 * Contexto (inicializado como undefined para forçar checagem)
 */
const PacoteContext = createContext<PacoteContextType | undefined>(undefined);

/**
 * Provider
 */
export const PacoteProvider = ({ children }: { children: ReactNode }) => {
  const [pacotes, setPacotes] = useState<PacoteDTO[]>([]);

  return (
    <PacoteContext.Provider value={{ pacotes, setPacotes }}>
      {children}
    </PacoteContext.Provider>
  );
};

/**
 * Hook utilitário para consumir o contexto com validação
 */
export const usePacote = (): PacoteContextType => {
  const ctx = useContext(PacoteContext);
  if (!ctx) {
    throw new Error("usePacote must be used within a PacoteProvider");
  }
  return ctx;
};
